import { inputPassword } from '@/shared/constants/appConstants'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const DataLine = ({
    fieldName,
    value,
    type,
}: {
    fieldName: string
    value: string
    type?: string
}) => {
    const { t: translate } = useTranslation()
    const displayValue =
        type === inputPassword ? '•'.repeat(value.length) : translate(value)

    const containerStyle = {
        display: 'flex',
        columnGap: '16px',
        mt: '8px',
        height: '28px',
    }
    const textStyle = {
        color: 'white',
        typography: 'label3',
        lineHeight: '19px',
    }

    return (
        <Box sx={containerStyle}>
            <Typography sx={textStyle}>{translate(fieldName)}:</Typography>
            <Typography sx={textStyle}>{displayValue}</Typography>
        </Box>
    )
}

export { DataLine }
